








































































































import { ApiResponse } from '@ustra/data/src/models/api-model'
import { HttpMethod } from '@ustra/core/src/server/http/const'
import { Component } from 'vue-property-decorator'
import { HsComponent } from '@hds/help-common/src/components/hs-components'
import { OnError } from '@ustra/nuxt/src/vue/decorators'
import vencdEventBus, { VenCdEventState } from '~/event-bus/vencd-event-bus'
import { VenChangeResult } from '~/model/vendor-search-model'
import HsVenSearchBtn from '~/components/common/hs-ven-search-btn.vue'

@Component({
  name: 'VenderChoice',
  components: { HsVenSearchBtn },
})

/**
 * @vuese
 * @group component group
 * component description
 */
export default class extends HsComponent {
  searchVenPop = false
  activeAlert = false
  // 협력사 인풋
  venPrimary = {
    venCd: null,
    venNm: null,
    ven2CdCnt: null,
  }

  venSecondary = {
    venCd: this.venPrimary.venCd,
    ven2Cd: null,
    ven2Nm: null,
  }

  // 2차 협력사 카드 스위치
  secondVenToggle = false
  secVenDisabled = true

  // #endregion
  // #region hooks

  mounted() {
    vencdEventBus.on(async (state: VenCdEventState) => {
      this.activeAlert = state.activeAlert
      // 화면 활성화
      if (this.activeAlert) await alert('협력사 코드를 선택해주세요.')
      console.log('@@@test: ', this.$ustra.hs.store.auth.currentUser)
      if (this.$ustra.hs.store.auth.currentUser.venCd) {
        const user = this.$ustra.hs.store.auth.currentUser
        console.log('@@@test: ', user)
        const result = await this.$ustra.api.call<ApiResponse<any>>({
          url: '/api/cm/vendor/selectVendorList',
          method: HttpMethod.POST,
          data: { venCd: user.venCd, venNm: user.venNm },
        })

        this.venPrimary = {
          venCd: user.venCd,
          venNm: user.venNm,
          ven2CdCnt: result.data.body[0].ven2CdCnt,
        }

        if (this.venPrimary.ven2CdCnt > 0) {
          this.secVenDisabled = false
        } else {
          this.secVenDisabled = true
        }

        this.secondVenToggle = user.ven2Cd !== null && user.ven2Cd !== '000000'

        this.venSecondary = {
          venCd: this.venPrimary.venCd,
          ven2Cd: user.ven2Cd,
          ven2Nm: user.ven2Nm,
        }
      }

      this.searchVenPop = true
    })
  }

  // #endregion
  // #region methods
  initInput() {
    this.venPrimary = {
      venCd: null,
      venNm: null,
      ven2CdCnt: 0,
    }

    this.venSecondary = {
      venCd: this.venPrimary.venCd,
      ven2Cd: null,
      ven2Nm: null,
    }
    this.secondVenToggle = false
  }

  onChangeSwitch() {
    this.venSecondary = {
      venCd: this.venPrimary.venCd,
      ven2Cd: null,
      ven2Nm: null,
    }
  }

  onClickSearch() {
    this.venSecondary = {
      venCd: this.venPrimary.venCd,
      ven2Cd: null,
      ven2Nm: null,
    }
    this.secondVenToggle = false
    if (this.venPrimary.ven2CdCnt > 0) {
      this.secVenDisabled = false
    } else {
      this.secVenDisabled = true
    }
  }

  async onClickVenConfirm(venConfirm) {
    this.searchVenPop = true
    if (venConfirm) {
      if (this.venPrimary.venCd === null) {
        alert('입력된 협력사가 없습니다.')
      } else {
        await this.callVenChange(this.venPrimary.venCd, this.venPrimary.venNm, this.venSecondary.ven2Cd, this.venSecondary.ven2Nm)
        this.$ustra.router.reload()
      }
    } else if (this.activeAlert && this.venPrimary.venCd === null) {
      if (await confirm('협력사 미선택시 해당 메뉴를 사용할 수 없습니다. 해당 메뉴를 닫으시겠습니까?')) {
        this.searchVenPop = false
        this.$ustra.router.push('/')
      } else {
        this.searchVenPop = true
      }
    } else {
      this.searchVenPop = false
    }
  }

  async resetVenChoice() {
    if (await confirm('기존 저장값을 모두 삭제하겠습니까?')) {
      this.initInput()
      await this.callVenChange(this.venPrimary.venCd, this.venPrimary.venNm, this.venSecondary.ven2Cd, this.venSecondary.ven2Nm)
    }
  }

  @OnError()
  async callVenChange(venCd, venNm, ven2Cd, ven2Nm) {
    const result = await this.$ustra.api.call<ApiResponse<VenChangeResult>>({
      url: '/api/admin/updateUserVenCd',
      method: HttpMethod.POST,
      data: { venCd, venNm, ven2Cd, ven2Nm },
    })

    if (result.data.resultCode === '0000') {
      await alert('협력사가 변경되었습니다.')
      this.$ustra.hs.store.auth.loadUserInfo()
      this.searchVenPop = false
    }
  }
  // #endregion
  // #region watches
  // #endregion
}
